import React from 'react';
import { IAbilities, IAuth, IUserStore, IOrganizationStore, } from '@Store';
import { IPreviewAudit, EnumTranslateTitle, EnumListSearchProps, TAuditSortableListCol, AuditSeverityEnum, } from 'atlas-shared';
import { getFullName, tableColumnDatetimeSorter, timeSince, } from '@Utils';
import { TFunction, } from 'i18next';
import { NavigateFunction, } from 'react-router';
import { ColumnsType, } from 'antd/lib/table/interface';
import { GetColumnSearchProps, GetColumnSearchEqualProps, } from '../components';
import { IWithListProps, } from '@Hocs/with.list';

export const AuditListColumns = (t: TFunction, navigate: NavigateFunction, showDeleted: boolean, users: IUserStore, organizations: IOrganizationStore, abilities: IAbilities, auth: IAuth, buttons: Array<(row: IPreviewAudit) => React.ReactElement> = [], filters: IWithListProps<IPreviewAudit, TAuditSortableListCol>['filters'], sorter: IWithListProps<IPreviewAudit, TAuditSortableListCol>['sorter']): ColumnsType<IPreviewAudit> => {
  return [
    {
      title: t('ID'),
      dataIndex: 'id',
      key: 'id',
      sorter: (a: IPreviewAudit, b: IPreviewAudit) => a.id - b.id,
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'id')?.order || null,
      filteredValue: filters.id || null,
      ...GetColumnSearchEqualProps(t, 'id', t('ID')),
      className: 'table-cell-id',
    },
    {
      title: t('USER'),
      dataIndex: 'user_id',
      key: 'user_id',
      render: (user_id: IPreviewAudit['user_id'], audit: IPreviewAudit) => user_id === -1 ? t('SYS_USER') : users.dict?.[user_id] ? getFullName(users.dict[user_id]) : t('USER_NOT_FOUND', { replace: { user_id, }, }),
      sorter: (a: IPreviewAudit, b: IPreviewAudit) => (users.dict?.[a.user_id] ? a.user_id === -1 ? t('SYS_USER') : getFullName(users.dict?.[a.user_id]) : '').localeCompare(users.dict?.[b.user_id] ? getFullName(users.dict?.[b.user_id]) : ''),
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'user_id')?.order || null,
      className: 'table-cell-user_id',
    },
    {
      title: t('ACTION'),
      dataIndex: 'action',
      key: 'action',
      render: (action: IPreviewAudit['action'], audit: IPreviewAudit) => EnumTranslateTitle('AUDIT_ACTION', action, t),
      sorter: (a: IPreviewAudit, b: IPreviewAudit) => EnumTranslateTitle('AUDIT_ACTION', a.action, t).localeCompare(EnumTranslateTitle('AUDIT_ACTION', b.action, t)),
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'action')?.order || null,
      className: 'table-cell-action',
    },
    {
      title: t('SEVERITY'),
      dataIndex: 'severity',
      key: 'severity',
      render: (severity: IPreviewAudit['severity'], audit: IPreviewAudit) => EnumTranslateTitle('AUDIT_SEVERITY', severity, t),
      sorter: (a: IPreviewAudit, b: IPreviewAudit) => EnumTranslateTitle('AUDIT_SEVERITY', a.severity, t).localeCompare(EnumTranslateTitle('AUDIT_SEVERITY', b.severity, t)),
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'severity')?.order || null,
      filteredValue: filters.severity || null,
      ...GetColumnSearchProps(t, 'severity', t('SEVERITY'), EnumListSearchProps('AUDIT_SEVERITY', AuditSeverityEnum, t)),
      className: 'table-cell-severity',
    },
    {
      title: t('CREATED_AT'),
      dataIndex: 'created_at',
      key: 'created_at',
      render: (created_at: IPreviewAudit['created_at'], audit: IPreviewAudit) => <div className='date-column'>{created_at ? timeSince(t, new Date(created_at), true) : ''}</div>,
      sorter: (a: IPreviewAudit, b: IPreviewAudit) => tableColumnDatetimeSorter(a.created_at, b.created_at),
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'created_at')?.order || null,
      className: 'table-cell-created_at',
    },
    
    {
      title: '',
      dataIndex: 'operation',
      key: 'operation',
      render: (_: any, row: IPreviewAudit) => (
        <div className={'table-operation-wrp'}>
          {buttons.map(button => button(row))}
        </div>
      ),
    },
  ].filter(Boolean) as ColumnsType<IPreviewAudit>;

};
